import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CardComponent } from '../../../../ui/card/card.component';
import { ButtonComponent } from '../../../../ui/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { TestsTabComponent } from '../../../../../shared/tables/tests-tab/tests-tab.component';
import { StudentTestsComponent } from '../../../../../shared/tables/student-tests/student-tests.component';

@Component({
  selector: 'app-exam',
  standalone: true,
  imports: [CommonModule, StudentTestsComponent, TranslateModule, RouterOutlet],
  templateUrl: './exam.component.html',
  styleUrl: './exam.component.css',
})
export class ExamComponent {
  activeTab: 'active' | 'archived' = 'active';
}
